/**
 * Created by eliranm on 05/10/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var CONST = require('const');
    var LocaleResolver = require('i18n/localeResolver');
    var NumberFormats = require('infra-util/NumberFormats');
    var Config = require('content-config/contentImportConfig.json');
    var Page = require('ui.components/page/Page');
    var ContentImportLayoutModel = require('content-models/ContentImportLayoutModel');
    var ContentImportLayout = require('content-views/content-import/ContentImportLayout');
    var ContentImportInstructionsView = require('content-views/content-import/ContentImportInstructionsView');
    var ContentCannedExportModel = require('content-models/canned/ContentCannedExportModel');
    var ContentImportCommandController = require('content-controllers/ContentImportCommandController');

    var CONFIG = {
        WRONG_HEADERS_MESSAGE_SPLIT_REG_EXP: /\]\[|\[|\]/g,
        STATES: {
            IDLE: 'idle',
            RUNNING: 'running',
            COMPLETED_SUCCESS: 'completed-success',
            COMPLETED_ERROR_GENERAL: 'completed-error-general',
            COMPLETED_ERROR_CONTENT: 'completed-error-content'
        }
    };

    var ContentImportController = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportController = Marionette.Controller.extend({

            state: null,

            // overridden

            initialize: function () {
                this.channel = LEContent.media.channel(Config.media.channel);
                this.vent = this.channel.vent;
                this.state = CONFIG.STATES.IDLE;

                this._initSubControllers();
                this._initModels();
                this._initViews();
                this._bindEvents();
            },

            onClose: function () {
                this._destruct();
            },

            // public

            getMainView: function () {
                return this.contentImportPage;
            },

            showImportCannedContent: function () {
                LEContent.logger.info('showing import canned content', 'ContentImportController:showImportCannedContent');
                this._showImportPageContents();
            },

            // private

            _initSubControllers: function () {
                this.commandController = new ContentImportCommandController();
            },

            _initModels: function () {
                this.contentImportLayoutModel = new ContentImportLayoutModel();
            },

            _initViews: function () {
                this.contentImportInstructionsView = null;

                this.contentImportLayout = new ContentImportLayout({
                    vent: this.vent,
                    model: this.contentImportLayoutModel
                });

                this.contentImportPage = new Page({
                    moduleName:LEContent.moduleName,
                    context:LE.context,
                    view: this.contentImportLayout,
                    header: this.contentImportLayoutModel.getHeader()
                });

                this.listenTo(this.contentImportPage, 'close', this._reconstruct);
                this.listenTo(this.contentImportPage, 'show', this._onImportPageShow);
            },

            _bindEvents: function () {
                this.listenTo(this.vent, Config.events.closePageDelegate, this._onImportPageClose);
                this.listenTo(this.vent, Config.events.submitImport, this._onSubmitImport);
                this.listenTo(this.vent, Config.events.downloadCurrentContent, this._onDownloadCurrentContent);
                this.listenTo(this.vent, Config.events.uploader.fileSelectionChange, this._onUploaderFileSelectionChange);
                this.listenTo(this.vent, Config.events.uploader.uploadStart, this._onUploaderUploadStart);
                this.listenTo(this.vent, Config.events.uploader.uploadComplete, this._onUploaderUploadComplete);
                this.listenTo(this.vent, Config.events.uploader.error, this._onUploaderError);
                this.listenTo(this.vent, Config.events.uploader.initSuccess, this._onUploaderInitSuccess);

                this.listenTo(LEContent.vent, 'content:cannedCollection:fetch:success', this._onCannedContentCollectionFetchSuccess);
            },

            _reconstruct: function () {
                this._destruct();
                this._initViews();
            },

            _destruct: function () {
                this.vent.stopListening();
                if (this.contentImportInstructionsView) {
                    this.contentImportInstructionsView.close();
                }
                this.contentImportLayout.close();
                this.contentImportPage.close();
            },

            _enableImport: function () {
                this.contentImportLayout.enableImport();
            },

            _disableImport: function () {
                this.contentImportLayout.disableImport();
            },

            _toggleImportButtonEnabled: function (enable) {
                if (enable) {
                    this._enableImport();
                } else {
                    this._disableImport();
                }
            },

            _navigateToCannedContent: function () {
                LEContent.router.navigateNonBackable(Config.routes.canned);
            },

            _navigateBack: function () {
                LEContent.router.navigateBack();
                //LEContent.router.navigate(Config.routes.canned);
            },

            _navigateToImport: function () {
                LEContent.router.navigate(Config.routes.import);
            },

            _navigateToImportErrors: function () {
                LEContent.router.navigate(Config.routes.importErrors);
            },

            _navigateToCampaigns: function () {
                LE.router.navigate(Config.routes.campaigns);
            },

            _navigateAwayFromRunInBackgroundLoader: function () {
                var cannedContentPreviousRoute = LEContent.context.get(LEContent.context.KEYS.cannedContentPreviousApplicationRoute);
                // navigation to these routes will route back to import page if running in background, prevent it
                var restrictedRoutes = [
                    Config.routes.canned,
                    Config.routes.import,
                    Config.routes.importErrors
                ];
                if (cannedContentPreviousRoute && cannedContentPreviousRoute.route && !_.contains(restrictedRoutes, cannedContentPreviousRoute.route)) {
                    LE.router.navigateNonBackable(cannedContentPreviousRoute.fixedRoute);
                    LEContent.context.remove(LEContent.context.KEYS.cannedContentPreviousApplicationRoute);
                } else {
                    // if there's no route to navigate to (user started the application from canned content or from
                    // import page), arbitrarily go to campaigns.
                    this._navigateToCampaigns();
                }
            },

            // this is called on the page 'show' event, before _showImportPageContents is called
            _onImportPageShow: function () {
                LEContent.logger.info('import page > show', 'ContentImportController:_onImportPageShow');
                // restore previous state
                if (this._isImportRunningInBackground()) {
                    this.commandController.setMode(ContentImportCommandController.CONFIG.mode.FOREGROUND);
                    this._setRunningMode();
                } else if (CONFIG.STATES.COMPLETED_ERROR_GENERAL !== this.state && CONFIG.STATES.RUNNING !== this.state) {
                    this._showImportPageLoader(); // this will be closed when import page components are finished loading
                }
            },

            // this is delegated by a call from the route controller, after the page 'show' event triggered and
            // _showImportPageContents was called
            _showImportPageContents: function () {
                LEContent.logger.info('import page > show contents', 'ContentImportController:_showImportPageContents');
                // the import page is not closed when navigating away, preserve the state by not re-initializing the contents if needed
                if (this.contentImportInstructionsView &&
                    (CONFIG.STATES.COMPLETED_ERROR_GENERAL === this.state || CONFIG.STATES.RUNNING === this.state)) {
                    // don't re-render the page, we need to preserve its state
                    return;
                }
                this._toggleImportButtonEnabled(false);
                // create and show the view
                this.contentImportInstructionsView = new ContentImportInstructionsView({
                    vent: this.vent
                });
                this.contentImportLayout.instructionsRegion.show(this.contentImportInstructionsView);
            },

            _onImportPageClose: function () {
                LEContent.logger.info('import page > close', 'ContentImportController:_onImportPageClose');
                this._navigateBack();
            },

            _onDownloadCurrentContent: function () {
                this._downloadCurrentContent();
            },

            _onSubmitImport: function () {
                this._initiateUploadProcess();
            },

            _onUploaderFileSelectionChange: function (data) {
                LEContent.logger.info('file selection change', 'ContentImportController:_onUploaderFileSelectionChange', data);
                var fileSizeValid;
                if (data.file) {
                    fileSizeValid = this._validateFileSize(data.file.size);
                    if (!fileSizeValid) {
                        this._showFileSizeInvalidErrorsBeforeUpload();
                    }
                }
                this._toggleImportButtonEnabled(data.file && fileSizeValid);
            },

            _initiateUploadProcess: function () {
                this.state = CONFIG.STATES.RUNNING;
                this.commandController.reset();
                this._setRunningMode();
                this._downloadCurrentContent(
                    _.bind(this._startUpload, this),
                    _.bind(this._closeImportPageLoaderAndShowGeneralErrorMessage, this));
            },

            _startUpload: function () {
                this.contentImportInstructionsView.startUpload();
            },

            _onUploaderUploadStart: function (data) {
                LEContent.logger.info('uploader upload start', 'ContentImportController:_onUploaderUploadStart', data);
            },

            _onUploaderUploadComplete: function (data) {
                LEContent.logger.info('uploader upload complete', 'ContentImportController:_onUploaderUploadComplete', data);

                if (Config.uploadCompleteResponseState.SUCCESS !== data.state) {
                    LEContent.logger.graph({name: "content:ContentImportController:uploader:error"});
                    LEContent.logger.error('uploader upload failed', 'ContentImportController:_onUploaderUploadComplete', data);
                    return;
                }

                var response = data.message;
                if (!response) { // no response body means the upload was successful
                    this._handleSuccess(); // loader is closed later as this handler is async
                } else {
                    this._closeImportPageLoader();
                    if (response.rows) {
                        this._handleContentError(response);
                    } else if (response.internalCode || Config.uploadCompleteInternalResponseStatus.BAD_REQUEST === response.responseStatus) {
                        this._handleGeneralError(response);
                    }
                }
            },

            _onUploaderError: function (data) {
                LEContent.logger.error('uploader error', 'ContentImportController:_onUploaderError', data);
                this._closeImportPageLoaderAndShowGeneralErrorMessage();
            },

            _onUploaderInitSuccess: function () {
                LEContent.logger.info('uploader init success', 'ContentImportController:_onUploaderInitSuccess');
                this._closeImportPageLoader();
            },

            _onRunInBackgroundClick: function () {
                LEContent.logger.info('loader button clicked (run in background requested)', 'ContentImportController:_onRunInBackgroundClick');
                // this will trigger _onActiveModuleChange after the navigation and will set the state accordingly
                this._navigateAwayFromRunInBackgroundLoader();
            },

            _onActiveModuleChange: function (model, activeModuleName) {
                // after the module change, check if we moved from import page to another module
                // this happens when the background loader is on and we navigate away, either by
                // clicking 'run in background' or by clicking on a module's button in the top bar
                if (CONST.MODULES.CONTENT !== activeModuleName && LE.context.get('previousApplicationRoute.route') === Config.routes.import) {
                    LEContent.logger.info('we moved to a different module, change state to running in background', 'ContentImportController:_onContentModuleNavigateAway');
                    this._runInBackground();
                    this._removeActiveModuleChangeListener();
                }
            },

            _runInBackground: function () {
                this.commandController.invoke(ContentImportCommandController.COMMAND_TYPE.PROGRESS, this._navigateToImport);
                this._closeImportPageLoader();
            },

            _setRunningMode: function () {
                this._addActiveModuleChangeListener();
                this._showRunInBackgroundLoader();
            },

            _handleSuccess: function () {
                LEContent.logger.info('handling import success', 'ContentImportController:_handleSuccess');
                this.state = CONFIG.STATES.COMPLETED_SUCCESS;
                // trigger reload of canned content collection and wait for success callback (we relay on the assumption that
                // at this point, the route cannot be at 'canned/content', as it's blocked while import is in progress)
                LEContent.vent.trigger('contentGallery:reloadCollection');
            },

            // called after reloading the canned content collection, after successfully importing items
            _onCannedContentCollectionFetchSuccess: function (collection) {
                LEContent.logger.info('fetch content collection success', 'ContentImportController:_onCannedContentCollectionFetchSuccess');
                if (!collection) {
                    return;
                }
                if (CONFIG.STATES.COMPLETED_SUCCESS === this.state) {
                    this._closeImportPageLoader();
                    this._invokeSuccessCommand(collection.size());
                    this.state = CONFIG.STATES.IDLE;
                }
            },

            // this is a general error - show it in an alert message and show that message in an error tooltip of the file label
            _handleGeneralError: function (data) {
                var fileUploaderErrorMessage = this._getFileUploaderErrorMessageByCode(data.internalCode, data.message);
                var notificationErrorMessage = LE.translator.translate(Config.i18n.notifications.referAfterUpload);
                this._invokeGeneralErrorCommand(notificationErrorMessage, fileUploaderErrorMessage, true);
            },

            // this is an error within content - show errors page
            _handleContentError: function (data) {
                this.state = CONFIG.STATES.COMPLETED_ERROR_CONTENT;
                var foregroundOrBackgroundCommand = function () {
                    this._prepareAndNavigateToImportErrors(data);
                    this.state = CONFIG.STATES.IDLE;
                };
                this.commandController.invoke(
                    ContentImportCommandController.COMMAND_TYPE.ERROR,
                    foregroundOrBackgroundCommand,
                    function () {
                        this._removeActiveModuleChangeListener();
                        foregroundOrBackgroundCommand.call(this);
                    }, {
                        commandsContext: this
                    });
            },

            _prepareAndNavigateToImportErrors: function (importErrorsResponse) {
                LEContent.context.set(LEContent.context.KEYS.contentImportErrorsResponse, importErrorsResponse);
                this._navigateToImportErrors();
            },

            _invokeSuccessCommand: function (importedItemsSize) {
                this.commandController.invoke(
                    ContentImportCommandController.COMMAND_TYPE.SUCCESS,
                    this._navigateToCannedContent,
                    function () {
                        this._removeActiveModuleChangeListener();
                        this._navigateToCannedContent();
                        this._showSuccessMessageInNotifier(importedItemsSize);
                    }, {
                        notificationMessageArgs: [importedItemsSize],
                        commandsContext: this
                    });
            },

            _invokeGeneralErrorCommand: function (notificationErrorMessage, fileUploaderErrorMessage, updateState) {
                if (updateState) {
                    this.state = CONFIG.STATES.COMPLETED_ERROR_GENERAL;
                }
                this.commandController.invoke(
                    ContentImportCommandController.COMMAND_TYPE.ERROR,
                    function () {
                        this._navigateToImport();
                        // using deferred execution to avoid a situation where file-upload-input error bubble is in an
                        // unexpected position and is not visible. this happens because when the import page is rendered
                        // and shown, its container's calculated position may be outside the viewport. see jira issue LE-23940.
                        _.defer(_.bind(this._showFileUploadErrors, this), notificationErrorMessage, fileUploaderErrorMessage);
                        if (updateState) {
                            this.state = CONFIG.STATES.IDLE;
                        }
                    },
                    function () {
                        this._removeActiveModuleChangeListener();
                        this._showFileUploadErrors(notificationErrorMessage, fileUploaderErrorMessage);
                        if (updateState) {
                            this.state = CONFIG.STATES.IDLE;
                        }
                    }, {
                        commandsContext: this
                    });
            },

            _showSuccessMessageInNotifier: function (importedItemsSize) {
                LEContent.notifier.showSuccess(LE.translator.translate({
                    key: 'LEContent.content.import.notification.success',
                    args: [
                        importedItemsSize,
                        {
                            key: NumberFormats.isPlural(importedItemsSize) ? 'LEContent.content.import.notification.success.plural' : 'LEContent.content.import.notification.success.singular',
                            isTranslate: true
                        }
                    ]
                }));
            },

            _showFileUploadErrors: function (notificationErrorMessage, fileUploaderErrorMessage) {
                LEContent.logger.debug('showing file upload errors', 'ContentImportController:_showFileUploadErrors', {
                    notificationErrorMessage: notificationErrorMessage,
                    fileUploaderErrorMessage: fileUploaderErrorMessage
                });
                LEContent.notifier.showError(notificationErrorMessage);
                if (fileUploaderErrorMessage) {
                    this.contentImportInstructionsView.setFileUploadError(fileUploaderErrorMessage);
                }
            },

            _showFileSizeInvalidErrorsBeforeUpload: function () {
                var notificationErrorMessage = LE.translator.translate(Config.i18n.notifications.referBeforeUpload);
                var fileUploaderErrorMessage = this._getFileUploaderErrorMessageByCode(Config.errorCodeMap.fileSize, Config.fileSizeLimitInMb);
                this._showFileUploadErrors(notificationErrorMessage, fileUploaderErrorMessage);
            },

            _getFileUploaderErrorMessageByCode: function (errorCode, serverErrorMessage) {
                var messageParam,
                    translationKey,
                    messageArgValues = [];
                if (_.isNaN(errorCode)) {
                    LEContent.logger.graph({name: "content:ContentImportController:uploader:error"});
                    LEContent.logger.error('error code is not a number, or is undefined', 'ContentImportController:_getFileUploaderErrorMessageByCode', errorCode);
                    return false;
                }
                translationKey = 'LEContent.content.import.serverError.' + errorCode;
                if (LE.translator.hasTranslationKey(LocaleResolver.getDefaultLocale(), translationKey)) {
                    messageParam = {key: translationKey};
                    // some errors require injecting variables into placeholders in the message
                    this._populateErrorMessageFirstArgument(errorCode, messageArgValues, serverErrorMessage);
                    if (messageArgValues.length) {
                        messageParam.args = [];
                        _.each(messageArgValues, function (val) {
                            messageParam.args.push({key: val});
                        });
                    }
                } else {
                    messageParam = 'LEContent.content.import.serverError.unknownError';
                }
                return LE.translator.translate(messageParam);
            },

            _populateErrorMessageFirstArgument: function (errorCode, messageArgValues, serverErrorMessage) {
                if (_.contains(Config.dynamicErrors.serverMessageArgs, errorCode)) {
                    messageArgValues.push(this._formatServerMessage(serverErrorMessage));
                } else if (_.contains(Config.dynamicErrors.cannedItemsMaxSize, errorCode)) {
                    messageArgValues.push(Config.cannedItemsMaxSize);
                } else if (_.contains(Config.dynamicErrors.wrongHeaders, errorCode)) {
                    messageArgValues.push(this._getWrongHeadersFragment(serverErrorMessage));
                }
            },

            _getWrongHeadersFragment: function (message) {
                var expectedToActualMap = this._parseWrongHeadersServerMessage(message || '');
                if (!_.size(expectedToActualMap)) {
                    return '';
                }
                return this._renderWrongHeadersFragment(expectedToActualMap);
            },

            /**
             * parses the wrong-headers message string into an object representation.
             * @param message a string in the format: '[expected value,actual value][foo,bar]'
             * @returns {array} an array in the format: [{expected: 'expected value', actual: 'actual value'},{expected: 'foo', actual: 'bar'}]
             * @private
             */
            _parseWrongHeadersServerMessage: function (message) {
                return _.map(_.compact(message.split(CONFIG.WRONG_HEADERS_MESSAGE_SPLIT_REG_EXP)), function (val) {
                    var entry = val.split(',');
                    return {expected: entry[0], actual: entry[1]};
                });
            },

            _renderWrongHeadersFragment: function (expectedToActualMap) {
                var listEl = $('<ul>');
                _.each(expectedToActualMap, function (val) {
                    // always use .text() and not .html() here to guard from XSS
                    listEl.append($('<li>').text(LE.translator.translate({
                        key: 'LEContent.content.import.serverError.headersMismatchEntry',
                        args: [
                            {key: val.actual},
                            {key: val.expected}
                        ]
                    })));
                });

                return $('<div>')
                    .addClass(Config.css.wrongHeadersList)
                    .append(listEl)[0].outerHTML;
            },

            _formatServerMessage: function (args) {
                // args is expected as a comma separated string, if it's another type - do nothing
                if (!_.isString(args)) {
                    return args;
                }
                var arr = args.split(',');
                _.each(arr, function (val, index) {
                    arr[index] = '"' + val + '"';
                });
                return arr.join(', ');
            },

            _downloadCurrentContent: function (onSuccess, onError) {
                LEContent.logger.info('trying to export canned content...', 'ContentImportController:_downloadCurrentContent');
                var tempModel = new ContentCannedExportModel();
                tempModel.fetch({
                    success: function () {
                        LEContent.logger.info('export content success', 'ContentImportController:_downloadCurrentContent');
                        if (onSuccess && _.isFunction(onSuccess)) {
                            LEContent.logger.info('calling export content success callback', 'ContentImportController:_downloadCurrentContent');
                            onSuccess();
                        }
                    },
                    error: function () {
                        LEContent.logger.error('export content failed with error - cannot continue with import process', 'ContentImportController:_downloadCurrentContent');
                        if (onError && _.isFunction(onError)) {
                            LEContent.logger.info('calling export content error callback', 'ContentImportController:_downloadCurrentContent');
                            onError();
                        }
                    }
                });
            },

            _closeImportPageLoaderAndShowGeneralErrorMessage: function () {
                this._closeImportPageLoader();
                var errorMessage = LE.translator.translate(Config.i18n.notifications.general);
                this._invokeGeneralErrorCommand(errorMessage, errorMessage);
            },

            _addActiveModuleChangeListener: function () {
                this.listenTo(LE.context, 'change:activeModuleName', this._onActiveModuleChange);
            },

            _removeActiveModuleChangeListener: function () {
                this.stopListening(LE.context, 'change:activeModuleName');
            },

            _showImportPageLoader: function () {
                this.contentImportPage.showLoader();
            },

            _closeImportPageLoader: function () {
                this.contentImportPage.closeLoader();
            },

            _showRunInBackgroundLoader: function () {
                this.contentImportPage.showLoader({
                    text: LE.translator.translate('LEContent.content.import.loader.upload.text'),
                    button: {
                        text: LE.translator.translate('LEContent.content.import.loader.upload.buttonText'),
                        callback: _.bind(this._onRunInBackgroundClick, this),
                        tooltip: LE.translator.translate('LEContent.content.import.loader.upload.buttonTooltip')
                    }
                });
            },

            _isImportRunningInBackground: function () {
                return LEContent.context.is(LEContent.context.KEYS.cannedContentImportRunningInBackground);
            },

            _validateFileSize: function (sizeInBytes) {
                var valid,
                    sizeInMb,
                    formattedSize = NumberFormats.bytesToSize(
                        sizeInBytes,
                        NumberFormats.MEASUREMENT_SYSTEM.METRIC,
                        NumberFormats.FILE_SIZE_UNIT.MEGABYTES,
                        0);
                LEContent.logger.info('formatted file size: ', 'ContentImportController:_validateFileSize', formattedSize);
                if (formattedSize) {
                    sizeInMb = formattedSize.value;
                    if (!_.isNaN(sizeInMb) && sizeInMb <= Config.fileSizeLimitInMb) {
                        valid = true;
                    }
                }
                return valid;
            }

        });

    });

    return ContentImportController;
});
